function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #603bbb;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_24",
  "data-name": "Trazado 24",
  className: "cls-1",
  d: "M-283.963,137.816V121.477H-289.9v-6.759h5.937v-5.151c0-5.86,3.49-9.1,8.831-9.1a35.952,35.952,0,0,1,5.234.457v5.754h-2.948c-2.9,0-3.81,1.8-3.81,3.651v4.386h6.485l-1.037,6.759h-5.448v16.338a23.387,23.387,0,0,0,19.728-23.1A23.381,23.381,0,0,0-280.31,91.338a23.381,23.381,0,0,0-23.381,23.381A23.387,23.387,0,0,0-283.963,137.816Z",
  transform: "translate(303.691 -91.338)"
});

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.762,
    height: 46.478,
    viewBox: "0 0 46.762 46.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0f5c55e9.svg";
export { ForwardRef as ReactComponent };